import useUser from 'hooks/useUser';
import { removeCookieToken } from 'utils/cookieUtils';

const useProfile = () => {
  const { data: userData } = useUser();

  const handleLogoutClick = () => {
    removeCookieToken();
    window.location.href = `${process.env.REACT_APP_WEB_URL as string}`;
  };

  return {
    userName: userData?.userName,
    userEmail: userData?.userEmail,
    handleLogoutClick,
  };
};

export default useProfile;
